<template>
  <div>
    <b-modal
      class="modal-update-kpi"
      id="modal-update-kpi"
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      title="Update Key Performance Indicator"
    >
      <div class="mt-3 mr-4 ml-4">
        <h6 class="mb-3">Key Performance Indicator</h6>
        <b-table
          ref="table"
          v-show="list.length"
          striped
          :items="list"
          :fields="fields"
        >
          <template #cell(typeKpi)="{ index }">
            <b-form-group>
              <custom-select
                class="bg-white"
                v-model="list[index].typeKpi"
                :options="kpiTypeFilter.filters"
                @change="$refs.table.refresh()"
                placeholder="Select Key Performance Indicator"
              />
            </b-form-group>
          </template>
          <template #cell(weight)="{ index }">
            <b-form-group>
              <b-form-input class="text-center" type="number" v-model="list[index].weight"></b-form-input>
            </b-form-group>
          </template>
          <template #cell(target)="{ index }">
            <b-form-group>
              <b-form-input class="text-center" type="number" v-model="list[index].target"></b-form-input>
            </b-form-group>
          </template>
          <template #cell(realization)="{ index }">
            <b-form-group>
              <b-form-input class="text-center" type="number" v-model="list[index].realization"></b-form-input>
            </b-form-group>
          </template>
          <template #cell(score)="{ index }">
            <b-form-group>
              <b-form-input
                class="text-center vertical-baseline bg-white"
                type="number"
                v-model="list[index].score"
              >
              </b-form-input>
            </b-form-group>
          </template>
          <template #cell(finalScore)="{ index }">
            <b-form-group>
              <b-form-input
                class="text-center vertical-baseline bg-white"
                type="number"
                v-model="list[index].finalScore"
              >
              </b-form-input>
            </b-form-group>
          </template>
        </b-table>
      </div>
      <div class="mt-5 d-flex justify-content-center">
        <b-button
          class="text-white"
          variant="warning"
          type="submit"
          block
          @click="updateKpi"
        >
          Update
          <b-spinner
            v-if="isBusy"
            class="ml-1"
            label="Spinning"
            small
          />
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api'
export default {
  props: {
    kpi: {
      type: Array,
      default: () => []
    },
    objective: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [
        {
          id: '',
          objectiveId: '',
          objective: '',
          name: '',
          typeKpi: '',
          weight: '',
          target: '',
          realization: '',
          score: '',
          finalScore: ''
        }
      ],
      fields: [
        { key: 'objective', label: 'Objective', rowspan: 3, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'name', label: 'KPI', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'typeKpi', label: 'Type', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'weight', label: 'Weight', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'target', label: 'Target', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'realization', label: 'Realization', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'score', label: 'Score', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'finalScore', label: 'Final Score', thClass: 'text-center', tdClass: 'text-center' }
      ],
      optionKpiType: [],
      kpiTypeFilter: {
        show: true,
        filters: [
          'Maximize',
          'Minimize'
        ]
      },
      isBusy: false,
      messageResult: {
        message: '',
        variant: ''
      }
    }
  },
  methods: {
    KpiType(type) {
      if (type === true) {
        return 'Maximize'
      } else {
        return 'Minimize'
      }
    },
    convertStringTypeToBoolean(type) {
      if (type === 'Maximize') {
        return true
      } else {
        return false
      }
    },
    async updateKpi() {
      this.isBusy = true
      let summary = 0
      try {
        const promises = []
        for (const kpi of this.list) {
          if (
            kpi.weight !== '' &&
            kpi.target !== '' &&
            kpi.realization !== '' &&
            kpi.score !== '' &&
            kpi.finalScore !== ''
          ) {
            const payload = {
              kpiId: kpi.kpiId,
              objectiveId: kpi.objectiveId,
              name: kpi.name,
              type: this.convertStringTypeToBoolean(kpi.typeKpi),
              weight: parseInt(kpi.weight),
              target: parseInt(kpi.target),
              realization: parseInt(kpi.realization),
              score: parseInt(kpi.score),
              finalScore: parseInt(kpi.finalScore)
            }
            summary += payload.finalScore
            promises.push(api.kpi.update(kpi.id, payload))
          }
        }
        if (promises.length === 0) {
          this.isBusy = false
          this.sendResult('Update KPI failed', 'danger')
          return
        }
        await Promise.all(promises)
        this.updateSummaryKpi(summary)
        this.sendResult('Update KPI Success', 'success')
      } catch (error) {
        console.log(error)
        this.sendResult('Update KPI Failed', 'danger')
      }
      this.list = []
      this.$bvModal.hide('modal-update-kpi')
      this.isBusy = false
    },
    async updateSummaryKpi(summary) {
      try {
        await api.kpi.updateSummaryKpi(this.list[0].kpiId, { summary: summary })
      } catch (error) {
        console.log(error)
      }
    },
    sendResult(message, variant) {
      this.messageResult.message = message
      this.messageResult.variant = variant
      this.$emit('result-request', this.messageResult)
      this.$emit('refresh-table', true)
    }
  },
  watch: {
    kpi: {
      handler() {
        this.list = []
        this.kpi.forEach((item, i) => {
          this.objective.forEach(objective => {
            if (item.objectiveId === objective.id) {
              this.list.push({
                id: item.id,
                objective: objective.name,
                name: item.name,
                typeKpi: this.KpiType(item.type),
                weight: item.weight,
                target: item.target,
                realization: item.realization,
                score: item.score,
                finalScore: item.finalScore,
                kpiId: item.kpiId,
                objectiveId: item.objectiveId,
                _rowVariant: i % 2 === 0 ? 'warning' : null
              })
            }
          })
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.table th, .table td{
  vertical-align: center !important;
}
</style>
